/**
 * Arriving at a request WITH its discussion showing (#1069; owner change
 * 2026-09-11, routed to quick-dev after Story 2.2).
 *
 * The request-list marker (`DiscussionRowIndicator`) opens the request with
 * the panel already open; every other way into the request arrives with the
 * panel closed (Story 5.3). The two screens agree through this file: the list
 * builds the path here, and `RequestDetail` reads the flag here, so the
 * parameter name and its one accepted value are written exactly once.
 *
 * ⚠️ A QUERY PARAMETER, NOT SCREEN STATE, ON PURPOSE. `App.tsx` carries the
 * whole query string through `navigate` on web (`history.pushState`) and on
 * native (`__currentRoute`), and `RequestDetail.getQueryParam` reads either;
 * a piece of screen state would need a second contract per platform. The
 * flag is read ONCE, when the screen mounts (`useState` initialiser), so a
 * later close is not undone by a re-render, and it is never written back.
 */

export const DISCUSSION_QUERY_PARAM = 'discussion';

/** The one value that opens the panel on arrival. Anything else is ignored. */
export const DISCUSSION_QUERY_OPEN = 'open';

/**
 * The request-detail path that arrives with the discussion open. `id` is
 * encoded, like every other id the list puts in a path.
 */
export const requestDetailPathWithDiscussion = (requestId: string): string =>
  `/request-detail?id=${encodeURIComponent(
    requestId,
  )}&${DISCUSSION_QUERY_PARAM}=${DISCUSSION_QUERY_OPEN}`;

/**
 * Does this query value ask for the discussion open on arrival? Exact match
 * only: `'1'`, `'true'`, `'OPEN'` do not, so a stray value cannot open it.
 */
export const arrivesWithDiscussionOpen = (
  value: string | null | undefined,
): boolean => value === DISCUSSION_QUERY_OPEN;
